import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

function TopMetricsRow({ stats, totalLeads }) {
  const statusCounts = stats?.status_counts || {};

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Lead Funnel */}
      <Card className="card">
        <CardHeader>
          <CardTitle className="text-xl" style={{ fontFamily: 'Manrope' }}>Lead Funnel</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {[
              { label: "New", count: statusCounts.new || 0, color: "bg-blue-500" },
              { label: "Contacted", count: statusCounts.contacted || 0, color: "bg-yellow-500" },
              { label: "Qualified", count: statusCounts.qualified || 0, color: "bg-pink-500" },
              { label: "Existing Customer", count: statusCounts.existing_customer || 0, color: "bg-orange-500" },
              { label: "Converted", count: statusCounts.converted || 0, color: "bg-green-500" },
            ].map((stage) => {
              const percentage = totalLeads > 0 ? (stage.count / totalLeads) * 100 : 0;
              return (
                <div key={stage.label} className="space-y-2">
                  <div className="flex justify-between text-sm">
                    <span className="font-medium text-gray-700">{stage.label}</span>
                    <span className="text-gray-600">{stage.count} ({percentage.toFixed(1)}%)</span>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-3 overflow-hidden">
                    <div
                      className={`h-full ${stage.color} rounded-full transition-all duration-300`}
                      style={{ width: `${percentage}%` }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* Services Requested */}
      <Card className="card">
        <CardHeader>
          <CardTitle className="text-xl" style={{ fontFamily: 'Manrope' }}>Services Requested</CardTitle>
        </CardHeader>
        <CardContent>
          {stats?.service_counts && stats.service_counts.length > 0 ? (
            <div className="space-y-3">
              {stats.service_counts.map((service, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
                  <span className="font-medium text-gray-700 text-sm">{service._id}</span>
                  <span className="text-xl font-bold text-blue-600" style={{ fontFamily: 'Manrope' }}>{service.count}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-center py-8">No service data yet</p>
          )}
        </CardContent>
      </Card>

      {/* Top Sources */}
      <Card className="card">
        <CardHeader>
          <CardTitle className="text-xl" style={{ fontFamily: 'Manrope' }}>Top Lead Sources</CardTitle>
        </CardHeader>
        <CardContent>
          {stats?.top_sources && stats.top_sources.length > 0 ? (
            <div className="space-y-3">
              {stats.top_sources.map((source, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-purple-50 rounded-lg">
                  <span className="font-medium text-gray-700 text-sm">{source._id || 'Direct'}</span>
                  <span className="text-xl font-bold text-purple-600" style={{ fontFamily: 'Manrope' }}>{source.count}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-center py-8">No source data yet</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default TopMetricsRow;
